export const FETCH_ORDERS = 'FETCH_ORDERS'
export const FETCH_SINGLE_ORDER_BEGIN = 'FETCH_SINGLE_ORDER_BEGIN'
export const FETCH_SINGLE_ORDER_DONE = 'FETCH_SINGLE_ORDER_DONE'
export const FETCH_SINGLE_ORDER = 'FETCH_SINGLE_ORDER'
export const TOTAL_ORDER_COUNT = 'TOTAL_ORDER_COUNT'
export const FETCH_ORDERS_BEGIN = 'FETCH_ORDERS_BEGIN'
export const FETCH_ORDERS_END = 'FETCH_ORDERS_END'